module.exports = {
  en: {
    message: {
      logIn: 'Login',
      signUp: 'Sign up',
      signOut: 'Sign out',
      logOut: 'Logout',
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      invalidCredentials: 'Invalid credentials.',
      accountNotActive: 'Account not active.',
      profile: 'Profile',
      info: 'Info',
      changePassword: 'Change password',
      firstName: 'First name',
      lastName: 'Last name',
      companyName: 'Company name',
      companyWebsite: 'Company website',
      resetPasswordSuccess: 'Your password has been successfully reset.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      repeatNewPassword: 'Repeat new password',
      badCredentials: 'Bad credentials.',
      city: 'City',
      street: 'Street',
      state: 'Canton',
      country: 'Country',
      zipCode: 'Zip code',
      streetNr: 'Street number',
      update: 'Update',
      resetPassword: 'Reset password',
      sendEmail: 'Send email',
      emailNotFound: 'Email you provided does not exist in database.',
      resetLink: 'Link for resetting password was sent to the email you provided.',
      passwordMinLen: 'Password must be at least 8 characters long.',
      passwordsMatch: 'Passwords must match.',
      tokenExpired: 'Token for account activation is invalid or expired.',
      jobs: 'Jobs',
      listOfJobs: 'List of jobs',
      addNewJob: 'Add a new job',
      theNameOfTheJob: 'The name of the job',
      add: 'Add',
      contacts: 'Contacts',
      listOfContacts: 'List of contacts',
      addNewContact: 'Add a new contact',
      jobCreatedSuccessfully: 'BKP created succesfully.',
      jobsWithThisNameAlreadyExists: 'Job with provided name already exists.',
      thisFieldMayNotBeNull: 'You must set a value for this field.',
      thisFieldMayNotBeBlank: 'You have entered an empty value in this field.',
      activateAccount: 'Please change default password. You can modify it in Profile/Password change form.',
      changedPassword: 'You have successfully changed your password.',
      wrongCurrentPassword: 'Wrong current password.',
      ensureThisFieldHasAtLeast8Characters: 'This field must have at least 8 characters.',
      yes: 'Yes',
      no: 'No',
      confirmDelete: 'Are you sure that you want to delete ',
      updateJob: 'Update job',
      jobUpdatedSuccessfully: 'BKP updated successfully.',
      profileUpdated: 'Profile updated successfully.',
      providePhoneType: 'You must select phone type.',
      providePhoneNumber: 'You must provide a phone number.',
      phones: 'Phones',
      addPhones: 'Add phones',
      number: 'Number',
      noPhones: 'No phones.',
      privateMobile: 'Private mobile',
      businessMobile: 'Business mobile',
      home: 'Home',
      business: 'Business',
      other: 'Other',
      projects: 'Projects',
      dashboard: 'Dashboard',
      noResults: 'No results found.',
      selectJobs: 'Select jobs.',
      typeToSearch: 'Type to search',
      contactSuccessfullyAdded: 'Contact successfully added.',
      craftsman: 'Craftsman',
      manager: 'Manager',
      isManager: 'Craftsman',
      isCraftsman: 'Manager',
      userWithProvidedEmailAlreadyExists: 'User with provided email already exists.',
      userSuccessfullyCreated: 'User successfully created.',
      userSuccessfullyUpdated: 'User successfully updated.',
      updateContact: 'Update contact',
      enterAValidEmailAddress: 'Enter a valid email address.',
      selectContactType: 'Select contact type',
      filterContacts: 'Filter contacts',
      addProject: 'Add new project',
      editProject: 'Edit project',
      projectName: 'Project name',
      startDate: 'Start date',
      endDate: 'End date',
      description: 'Description',
      targetCost: 'Target cost',
      staticBudget: 'Static budget',
      projectCreatedSuccessfully: 'Project created succesfully.',
      name: 'Name',
      dateHasWrongFormatUseOneOfTheseFormatsInsteadYyyymmdd: 'Date has wrong format',
      aValidNumberIsRequired: 'A valid number is required.',
      thisOperationCanNotBeUndone: 'This operation can\'t be undone!',
      projectUpdatedSuccessfully: 'Project updated successfully.',
      noProjects: 'No projects',
      selectImage: 'Select image',
      upload: 'Upload',
      addUpdateCoverImage: 'Add / update cover image',
      coverImage: 'Cover image',
      basicInfo: 'basic information',
      confirmRemove: 'Are you sure that you want to remove',
      noStartDate: 'No start date',
      noEndDate: 'No end date',
      userWithThisEmailAlreadyExists: 'User with this e-mail already exists',
      fromTheProject: 'from the project',
      jobTypeOnProject: 'Job type on current project',
      status: 'Status',
      active: 'Active',
      notActive: 'Not active',
      noJobSelected: 'Job type not selected',
      user: 'User',
      withJob: 'with job',
      isAlreadyOnProject: 'is already on the project',
      addCraftsmenToProject: 'Add craftsmen to the project',
      searchForCraftsmenByCompanyName: 'Search for craftsmen by company name',
      selectCraftsmen: 'Select craftsmen from the list to add on the project',
      currentJobType: 'Current job type',
      listOfUsersActiveOnProject: 'List of craftsmen currently active on the project',
      successfullyAddedToProject: 'successfully added to project',
      projectStatus: 'Project status',
      pageNotFound: 'Sorry, page you have requested was not found',
      ensureThisValueIsGreaterThanOrEqualTo00: 'Ensure that this value is greater or equal to 0',
      startDateLater: 'Start date must be before end date.',
      categoriesPersonnel: 'Categories personnel',
      chfPerHour: 'CHF per hour',
      addCategoriesPersonnel: 'Add personnel categories',
      value: 'Value',
      material: 'Material',
      surcharge: 'Surcharge',
      foreignService: 'Foreign service',
      inventory: 'Inventory',
      amount: 'Amount',
      additionalCosts: 'Additional costs',
      addCostCategories: 'Add cost categories',
      currentDate: 'Current date',
      dateLastFriday: 'Date last Friday',
      addCategoriesMaterial: 'Add material categories',
      addCategoriesForeignService: 'Add foreign service categories',
      addCategoriesInventory: 'Add inventory categories',
      addCategoriesAdditionalCosts: 'Add additional costs categories',
      thisFieldIsRequired: 'This field is required',
      actualCosts: 'Actual costs',
      budget: 'Budget',
      summary: 'Summary',
      work: 'Work',
      date: 'Date',
      amountOfHours: 'Amount of hours',
      total: 'Total',
      costs: 'Costs',
      unit: 'Unit',
      costsUpdated: 'Costs updated successfully',
      orderByStartDate: 'Order by start date',
      selectCategoryForSorting: 'Select category for sorting',
      yourParticipationOnProject: 'Your participation on project',
      yourParticipationStarts: 'Your participation starts',
      yourParticipationEnds: 'Your participation ends',
      pleaseCreateCategory: 'Please create at least one cost category before proceeding to adding rows.',
      dynamicBudget: 'Dynamic budget',
      updateOverallDetails: 'Update overall details',
      addRowWithNewDate: 'Add row with new date',
      sheetSuccesfullyUpdated: 'Your task details have been successfully updated.',
      projectsWithThisNameAlreadyExists: 'Project with this name already exists.',
      preferredLanguage: 'Preferred language',
      filterProjects: 'Filter projects',
      addAnotherCostLine: 'Add another cost line for the same date',
      removeCostLine: 'Remove cost line',
      addACategory: 'Add a category',
      deviationFromTargetCosts: 'Deviation from target costs',
      deviationFromBudget: 'Deviation from budget',
      overallProjectData: 'Overall Project Data',
      downloadToCsv: 'Download CSV report',
      notPossibleToCalculate: 'Undefined',
      deleteCostRow: 'Are you sure that you want to delete row? It has already been saved in database',
      backToProjectPage: 'Back to project page',
      backToDashboard: 'Back to dashboard',
      leavePage: 'Do you really want to leave page? You have unsaved changes!',
      deleteRowNotAllowed: 'You cannot delete this row, there has to be one for every month. If there were no expenses, leave zeros.',
      addUpdateProfileImage: 'Add/update profile image on click',
      coverImageSuccesfullyUpdated: 'Cover image succesfully updated.',
      addUpdate: 'Add / update',
      rollingForecast: 'Rolling forecast',
      costsAndDates: ' costs and dates',
      setStartDateFor: 'Set start date for ',
      taskOnTheProject: '\'s task on the project',
      price: 'Price',
      nonFieldErrors: 'Other errors',
      passwordNotComplex: 'Please enter password at least 8 characters long, with at least 1 lower case character, 1 upper case character and at least 1 digit.',
      dateOutOfRange: 'Selected date must be in range of project start date and end date',
      youHaveToProvideStartDate: 'You have to provide start date for craftsman\'s work on project.',
      totalCostsProjectLeader: 'Total costs project leader',
      addDocument: 'Add a document',
      chooseFile: 'Choose file',
      documentSuccesfullyUploaded: 'Document(s) succesfully uploaded.',
      listAlreadyAdded: 'List of documents already added',
      renameUploadedFile: 'Please rename file to not contain white space.',
      companyAbbreviation: 'Company abbreviation',
      invoiced: 'Invoiced',
      file: 'File',
      theSubmittedDataWasNotAFileCheckTheEncodingTypeOnTheForm: 'Submitted file was not valid',
      lock: 'Lock',
      unlock: 'Unlock',
      budgetHistory: 'Budget history',
      totalInvoiced: 'Total invoiced',
      month: 'Month',
      filterDocumentsPerMonth: 'Filter documents per month',
      filter: 'Filter',
      cancel: 'Cancel',
      personnel_locked: 'Budget for personnel was closed by administrator. It will have to be approved by administrator before you can start using it.',
      material_locked: 'Budget for material was closed by administrator. It will have to be approved by administrator before you can start using it.',
      foreign_power_locked: 'Budget for foreign service was closed by administrator. It will have to be approved by administrator before you can start using it.',
      inventory_locked: 'Budget for inventory was closed by administrator. It will have to be approved by administrator before you can start using it.',
      additional_costs_locked: 'Budget for additional costs was closed by administrator. It will have to be approved by administrator before you can start using it.',
      approveUsingOf: 'Are you sure that you want approve using of',
      forbidUsingOf: 'Are you sure that you want to forbid using of',
      provideCorrectFormat: 'Please provide image in the correct jpg or png format.',
      requestAdditionalBudget: 'Request additional budget',
      additionalBudgetSuccessfullyRequested: 'You have successfully posted request for additional budget. You will be notified when administrator handles your request.',
      additionalBudgetAllowed: 'Additional budget allowed',
      lockAllBudget: 'Lock all budget',
      unlockAllBudget: 'Unlock all budget',
      youAreNotAble: 'You are not able to add additional categories if administrator has not allowed it.',
      theBudgetIsLocked: 'The budget is locked.',
      areSureConfirmBudget: 'Are you sure that you want to confirm budget and notify administrator?',
      areYouSureLock: 'Are you sure you want to lock all fields and inform the user?',
      areYouSureUnlock: 'Are you sure you want to unlock all fields and inform the user?',
      adminClosedBudget: 'Administrator has closed your budget.',
      adminOpenedBudget: 'Administrator has opened your budget.',
      updateCategoryName: 'Update category name',
      importCategories: 'Import categories',
      personnel: 'Personnel',
      selectedCategories: 'Selected categories',
      import: 'Import',
      selectProject: 'Select project',
      filterCraftsmen: 'Filter craftsmen',
      addBudgetFirst: 'You have to add budget before confirming that it is done.',
      documentSuccesfullyRemoved: 'Document succesfully removed.',
      areYouSureRemove: 'Are you sure you want to remove the selected document?',
      invoiceLineAdded: 'Invoice line succesfully added.',
      oopsSomethingWentWrong: 'Oooops! Something went wrong.',
      afterClickingPlsCheck: 'After clicking on the requested document, please check other tabs or downloads folder of your browser.',
      noCategoriesToImport: 'No categories to import.',
      contractNumber: 'Contract number',
      budgetDone: 'Budget done',
      inputAdditionalBudget: 'You have to input sum for additional budget.',
      hasRequestedAdditionalBudget: 'has requested additional budget of',
      notifications: 'Notifications',
      new: 'New',
      clearAll: 'Clear all',
      done: 'Done',
      tasks: 'Tasks',
      bkp: 'BKP',
      listOfBkp: 'List of BKP',
      selectBkp: 'Select BKP',
      backToTasks: 'Back to tasks',
      approve: 'Approve',
      deny: 'Deny',
      areYouSureThatYouWantToApprove: 'Are you sure that you want to approve additional budget for',
      areYouSureThatYouWantToDeny: 'Are you sure that you want to deny additional budget for',
      adminApprovedAdditionalBudget: 'Administrator has approved additional budget on your account',
      adminDeniedAdditionalBudget: 'Administrator has denied your request for additional budget',
      noNewTasks: 'No new tasks',
      noDoneTasks: 'No done tasks',
      additionalBudgetHistory: 'Additional budget history',
      addNewBkp: 'Add new BKP',
      theNameOfBkp: 'BKP Number',
      updateContract: 'Update contract',
      updateContractNumber: 'Update contract number',
      contractNoSuccesfullyUpdated: 'Contract number succesfully updated.',
      ensureThisValueIsGreaterThanOrEqualTo001: 'Please ensure that this value is greater then 0.',
      planner: 'Planner',
      descriptionInvoiceNumber: 'Description (Invoice number)',
      amountChfExclVat: 'Amount (CHF excl. VAT)',
      bkpDescription: 'BKP Description',
      updateBkp: 'Update BKP',
      searchForCraftsmenByBKP: 'Search for craftsmen by BKP',
      searchBy: 'Search by ',
      areYouSureDeleteBudget: 'Are you sure you want to delete this additional budget?',
      additionalBudgetSuccesfullyRemoved: 'Additional budget succesfully removed.',
      projectController: 'Project controller',
      plsSelectOne: 'Please select one',
      plsSetYourStaticBudget: 'Please set the static budget for your contract.',
      createdBy: 'Project controller',
      lockStaticBudget: 'Lock static budget',
      addUpdateProjectColor: 'Add / update project color',
      updateProjectColor: 'Update project color',
      mustSelectBKP: 'You have to select BKP before adding craftsmen to project.',
      addAdditionalBudget: 'Add additional budget',
      additionalBudgetSuccessfullyAdded: 'Additional budget succesfully added.',
      serialNumber: 'Serial number',
      offerNumber: 'Offer number',
      forMonth: 'For month',
      allAdditionalBudgetsSuccessfullyAdded: 'All additional budgets succesfully added.',
      companies: 'Companies',
      listOfCompanies: 'List of companies',
      addNewCompany: 'Add new company',
      companySuccessfullyCreated: 'Company succesfully created.',
      updateCompany: 'Update company',
      companySuccessfullyUpdated: 'Company succesfully updated.',
      removeAdditionalBudget: 'Remove additional budget',
      saveAdditionalBudget: 'Save additional budget',
      areYouSureYouWantAddUser: 'Are you sure that you want to add user with following data to project?',
      setContractNumber: 'Set contract number',
      contractNumberIsMandatoryField: 'Contract number is a mandatory field.',
      endDateOfSheetIsOutOfRangeOfProject: 'end date of sheet is out of range of project.',
      badRequest: 'Bad request',
      descriptionOrOfferNumberOrAdditionalBudgetDataNotCorrect: 'description or offer number or additional budget data not correct.',
      setStaticBudget: 'Set static budget',
      staticBudgetPlusAdditionalBudget: 'Static budget + Additional budget(s)',
      data:'Data',
      additionalBudget: 'Additional budget',
      settings: 'Settings',
      addUpdateAppLogo: 'Add/update application logo',
      addUpdateTabText: 'Add/update tab text',
      appDetailsUpdated: 'Application details succesfully updated.',
      features: 'FEATURES',
      reporting: 'Reporting',
      dynamicBudgetUpToCurrentMonth: 'Dynamic budget up to current month',
      actualCostsUpToCurrentMonth: 'Actual costs up to current month',
      dataTable: 'Data table',
      deviation: 'Deviation',
      showHide: 'Show / hide',
      show: 'Show',
      hide: 'Hide',
      informAutomaticContractNumber: 'Please also note that contract number field was empty and that it has been be set automatically.',
      rest:'rest',
      errors: 'Errors',
      notes: 'Notes',
      updateNotes: 'Update notes',
      addaNewNote: 'Add a new note',
      text: 'Note text',
      succesfullyAdded: 'succesfully added',
      note: 'Note',
      this: 'this',
      succesfullyDeleted: 'succesfully deleted',
      goToLockMonths: 'Go to lock months',
      lockMonths: 'Lock months',
      messaging: 'Messaging',
      subject: 'Subject',
      messageBody: 'Message body',
      send: 'Send',
      emailArchive: 'Email archive',
      sendEmailAlerts: 'Send email alerts',
      closeSheet: 'Close sheet',
      areYouSureDeleteCategory: 'Are you sure you want to delete this category?',
      category: 'Category',
      pleaseNoteCostsAlso: 'Please note all costs related to this category will be deleted also.',
      goToTaskHistory: 'Go to task history',
      taskHistory: 'Task history',
      details: 'Details',
      created: 'Created',
      approveadditionalbudget: 'Approve additional budget',
      admin: 'Admin',
      issuedBy: 'Issued by',
      showMoreRows: 'Show more rows',
      closedByAdministrator: 'Closed by administrator',
      lateWithInput: 'Missing entries previous month',
      lateWithInputCurrentMonth: 'Missing entries for current month',
      zeroValueAdded: 'Current month without charges',
      sheetClosed: 'Sheet closed',
      costsAdded: 'Costs added',
      dashboardVisibleForCraftsmen: 'Dashboard visible for craftsmen / planners',
      yourContracts: 'Your contracts',
      listOfWork:'List of work',
      addNewWork: 'Add new work',
      updateWork: 'Update work',
      theNameOfWork: 'Work number',
      workDescription: 'Work description',
      clickToAddCosts: 'Click to add costs',
      selectWork: 'Select work',
      job: 'Work',
      distributionActuals: 'Distribution of actual costs',
      distributionBudget: 'Distribution of budget costs',
      documents: 'Documents',
      createArchive: 'Create archive',
      invoice: 'Invoice',
      offer: 'Offer',
      action: 'Action',
      filterByCategory: 'Filter by category',
      archiveZipFile: 'Archive zip file is being generated. In a couple of minutes plesase visit',
      listArchivesCreated: 'List of archives created',
      creationCompleted: 'Creation completed',
      completed: 'Completed',
      notCompleted: 'Not completed',
      emailAlertSettingChangedSuccesfully: 'Email alert setting changed succesfully.'
    }
  },
  de: {
    message: {
      logIn: 'Login',
      signUp: 'Anmelden',
      signOut: 'Ausloggen',
      logOut: 'Ausloggen',
      email: 'Email',
      password: 'Passwort',
      rememberMe: 'Passwort speichern',
      forgotPassword: 'Passwort vergessen?',
      invalidCredentials: 'Ungültige Anmeldeinformationen.',
      accountNotActive: 'Konto nicht aktiv.',
      profile: 'Profil',
      info: 'Info',
      changePassword: 'Passwort ändern',
      firstName: 'Vorname',
      lastName: 'Nachname',
      companyName: 'Firmennamen',
      companyWebsite: 'Unternehmenswebseite',
      resetPasswordSuccess: 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      repeatNewPassword: 'Wiederholen Sie das neue Passwort',
      city: 'Stadt',
      street: 'Strasse',
      state: 'Kanton',
      country: 'Land',
      zipCode: 'PLZ',
      streetNr: 'Hausnummer',
      update: 'Aktualisieren',
      resetPassword: 'Passwort zurücksetzen',
      sendEmail: 'Email senden',
      emailNotFound: 'Die von ihnen angegebene Email existiert nicht.',
      resetLink: 'Der Link zum Zurücksetzen des Passworts wurde an Ihre Email-Adresse gesendet.',
      passwordMinLen: 'Passwörter müssen aus mindestens 8 Zeichen bestehen.',
      passwordsMatch: 'Die Passwörter müssen übereinstimmen.',
      tokenExpired: 'Der Token für die Kontoaktivierung ist ungültig oder abgelaufen.',
      jobs: 'Teilprojekte',
      listOfJobs: 'Liste der Teilprojekte',
      addNewJob: 'Neue Teilprojekte hinzufügen',
      theNameOfTheJob: 'Name des Teilprojektes',
      add: 'Hinzufügen',
      contacts: 'Kontakte',
      listOfContacts: 'Liste der Kontakte',
      addNewContact: 'Neuen Kontakt hinzufügen',
      jobCreatedSuccessfully: 'BKP erfolgreich erstellt.',
      jobsWithThisNameAlreadyExists: 'Teilprojekt mit angegebenem Namen ist bereits vorhanden.',
      thisFieldMayNotBeNull: 'Sie müssen einen Wert für dieses Feld angeben.',
      thisFieldMayNotBeBlank: 'Sie haben in dieses Feld keinen Wert eingegeben.',
      activateAccount: 'Bitte ändern Sie das Standard-Passwort. Sie können es im Profil ändern.',
      changedPassword: 'Sie haben Ihr Passwort erfolgreich geändert.',
      wrongCurrentPassword: 'Falsches Passwort.',
      ensureThisFieldHasAtLeast8Characters: 'Falsche Eingabe. Dieses Feld muss mindestens 8 Zeichen haben.',
      yes: 'Ja',
      no: 'Nein',
      confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten ',
      updateJob: 'Teilprojekt aktualisieren',
      jobUpdatedSuccessfully: 'BKP erfolgreich aktualisiert.',
      profileUpdated: 'Profil erfolgreich aktualisiert.',
      providePhoneType: 'Sie müssen den Telefontyp auswählen.',
      providePhoneNumber: 'Sie müssen eine Telefonnummer angeben.',
      phones: 'Telefone',
      addPhones: 'Telefone hinzufügen',
      number: 'Nummer',
      noPhones: 'Keine Telefone',
      privateMobile: 'Privates Mobiltelefon',
      businessMobile: 'Geschäftstelefon',
      home: 'Zuhause',
      business: 'Geschäft',
      other: 'Andere',
      projects: 'Projekte',
      dashboard: 'Dashboard',
      noResults: 'Keine Ergebnisse gefunden.',
      selectJobs: 'Teilprojekt auswählen.',
      typeToSearch: 'Hier tippen um zu suchen',
      contactSuccessfullyAdded: 'Kontakt erfolgreich hinzugefügt.',
      craftsman: 'Handwerker',
      manager: 'Manager',
      isManager: 'Handwerker',
      isCraftsman: 'Manager',
      userWithProvidedEmailAlreadyExists: 'Benutzer mit angegebener Email existiert bereits.',
      userSuccessfullyCreated: 'Der Benutzer wurde erfolgreich erstellt.',
      userSuccessfullyUpdated: 'Benutzer erfolgreich aktualisiert.',
      updateContact: 'Kontakt aktualisieren',
      enterAValidEmailAddress: 'Geben Sie eine gültige Email-Adresse an.',
      selectContactType: 'Kontakttyp auswählen',
      filterContacts: 'Kontakte filtern',
      addProject: 'Neues Projekt hinzufügen',
      editProject: 'Projekt bearbeiten',
      projectName: 'Projektname',
      startDate: 'Anfangsdatum',
      endDate: 'Endtermin',
      description: 'Beschreibung',
      targetCost: 'Kostenvoranschlag',
      staticBudget: 'Vertragsbudget',
      projectCreatedSuccessfully: 'Projekt erfolgreich angelegt.',
      name: 'Name',
      dateHasWrongFormatUseOneOfTheseFormatsInsteadYyyymmdd: 'Datum hat falsches Format',
      aValidNumberIsRequired: 'Eine gültige Nummer ist erforderlich.',
      thisOperationCanNotBeUndone: 'Dieser Vorgang kann nicht rückgängig gemacht werden!',
      projectUpdatedSuccessfully: 'Projekt erfolgreich aktualisiert.',
      noProjects: 'Keine Projekte',
      selectImage: 'Bild auswählen',
      upload: 'Hochladen',
      addUpdateCoverImage: 'Titelbild hinzufügen / Aktualisieren',
      coverImage: 'Titelbild',
      basicInfo: 'Basisinformationen',
      confirmRemove: 'Sind Sie sicher, dass Sie löschen möchten',
      noStartDate: 'Kein Startdatum',
      noEndDate: 'Kein Enddatum',
      userWithThisEmailAlreadyExists: 'Ein Benutzer existiert bereits mit dieser Email-Adresse',
      fromTheProject: 'aus dem Projekt',
      jobTypeOnProject: 'Auftragstyp für aktuelles Projekt',
      status: 'Status',
      active: 'Aktiv',
      notActive: 'Nicht aktiv',
      noJobSelected: 'Auftragstyp nicht ausgewählt',
      user: 'Benutzer',
      withJob: 'mit Job',
      isAlreadyOnProject: 'ist schon im Projekt',
      addCraftsmenToProject: 'Fügen Sie dem Projekt einen Handwerker dazu',
      searchForCraftsmenByCompanyName: 'Suche Handwerkern mit Firmennamen',
      selectCraftsmen: 'Wählen Sie Handwerker aus der Liste aus, die Sie dem Projekt hinzufügen möchten',
      currentJobType: 'Aktueller Jobtyp',
      listOfUsersActiveOnProject: 'Liste der derzeit im Projekt tätigen Handwerker',
      successfullyAddedToProject: 'Erfolgreich zum Projekt hinzugefügt',
      projectStatus: 'Projekt-Status',
      pageNotFound: 'Entschuldigung, die von Ihnen angeforderte Seite wurde nicht gefunden',
      ensureThisValueIsGreaterThanOrEqualTo00: 'Stellen Sie sicher, dass dieser Wert grösser oder gleich 0 ist',
      startDateLater: 'Das Startdatum muss vor dem Enddatum liegen.',
      categoriesPersonnel: 'Kategorien Personal',
      chfPerHour: 'CHF pro Stunde',
      addCategoriesPersonnel: 'Personalkategorien hinzufügen',
      value: 'Wert',
      material: 'Material',
      surcharge: 'Zuschlag',
      foreignService: 'Fremdleistungen',
      inventory: 'Inventar',
      amount: 'Betrag',
      additionalCosts: 'Nebenkosten',
      addCostCategories: 'Kostenkategorien hinzufügen',
      currentDate: 'Aktuelles Datum',
      dateLastFriday: 'Datum des letzten Freitags',
      addCategoriesMaterial: 'Materialkategorien hinzufügen',
      addCategoriesForeignService: 'Fügen Sie eine Kategorie Fremdleistungen hinzu',
      addCategoriesInventory: 'Inventarkategorien hinzufügen',
      addCategoriesAdditionalCosts: 'Fügen Sie zusätzliche Kategorien hinzu',
      thisFieldIsRequired: 'Dieses Feld wird benötigt',
      actualCosts: 'Kosten',
      budget: 'Budget',
      summary: 'Zusammenfassung',
      work: 'Gewerk',
      date: 'Datum',
      amountOfHours: 'Anzahl Stunden',
      total: 'Total',
      costs: 'Kosten',
      unit: 'Einheit',
      costsUpdated: 'Kosten wurden erfolgreich aktualisiert',
      orderByStartDate: 'Bestellung nach Startdatum',
      selectCategoryForSorting: 'Kategorie zum Sortieren auswählen',
      yourParticipationOnProject: 'Ihre Teilnahme am Projekt',
      yourParticipationStarts: 'Ihre Teilnahme beginnt',
      yourParticipationEnds: 'Ihre Teilnahme endet',
      pleaseCreateCategory: 'Bitte erstellen Sie mindestens eine Kostenkategorie, bevor Sie mit dem Hinzufügen von Zeilen fortfahren.',
      dynamicBudget: 'Monatliches Budget',
      updateOverallDetails: 'Aktualisieren Sie die allgemeinen Details',
      addRowWithNewDate: 'Zeile mit neuem Datum hinzufügen',
      sheetSuccesfullyUpdated: 'Ihre Aufgabendetails wurden erfolgreich aktualisiert.',
      projectsWithThisNameAlreadyExists: 'Projekt mit diesem Namen existiert bereits.',
      preferredLanguage: 'Bevorzugte Sprache',
      filterProjects: 'Projekte filtern',
      addAnotherCostLine: 'Fügen Sie eine weitere Kostenzeile für das selbe Datum hinzu',
      removeCostLine: 'Kostenzeile entfernen',
      addACategory: 'Kategorie hinzufügen',
      deviationFromTargetCosts: 'Abweichung zu Kostenvoranschlag',
      deviationFromBudget: 'Abweichung zu Budget',
      overallProjectData: 'Gesamtprojektdaten',
      downloadToCsv: 'CSV-Bericht herunterladen',
      notPossibleToCalculate: 'Nicht kalkulierbar',
      deleteCostRow: 'Möchten Sie die Zeile wirklich löschen? Diese wurde bereits in der Datenbank gespeichert',
      backToProjectPage: 'Zurück zur Projektseite',
      backToDashboard: 'Zurück zum Dashboard',
      leavePage: 'Möchten Sie die Seite wirklich verlassen? Sie haben nicht gespeicherte Änderungen!',
      deleteRowNotAllowed: 'Sie können diese Zeile nicht löschen, es muss eine Zeile für jede Monat geben. Wenn es keine Ausgaben gab, geben Sie Nullen ein.',
      addUpdateProfileImage: 'Profilbild beim Klicken hinzufügen / aktualisieren',
      coverImageSuccesfullyUpdated: 'Titelbild erfolgreich aktualisiert.',
      addUpdate: 'Hinzufügen / Aktualisieren',
      rollingForecast: 'Prognose',
      costsAndDates: ' Kosten und Daten',
      setStartDateFor: 'Startdatum einstellen für ',
      taskOnTheProject: ' Aufgabe auf dem Projekt',
      price: 'Preis',
      nonFieldErrors: 'Andere Fehler',
      passwordNotComplex: 'Bitte geben Sie ein mindestens 8 Zeichen langes Passwort mit mindestens 1 Kleinbuchstaben, 1 Großbuchstaben und mindestens 1 Ziffer ein.',
      dateOutOfRange: 'Das ausgewählte Datum muss im Bereich des Projektstart- und Enddatums liegen',
      youHaveToProvideStartDate: 'Sie müssen den Starttermin für die Arbeit des Handwerkers am Projekt angeben.',
      totalCostsProjectLeader: 'Gesamtkosten Projektleiter',
      addDocument: 'Fügen Sie ein Dokument hinzu',
      chooseFile: 'Wählen Sie eine Datei',
      documentSuccesfullyUploaded: 'Dokument(e) erfolgreich hochgeladen.',
      listAlreadyAdded: 'Liste der bereits hinzugefügten Dokumente',
      renameUploadedFile: 'Bitte benennen Sie die Datei so um, dass sie keinen Leerraum enthält.',
      companyAbbreviation: 'Firmenabkürzung',
      invoiced: 'Fakturieren',
      file: 'Datei',
      theSubmittedDataWasNotAFileCheckTheEncodingTypeOnTheForm: 'Die eingereichte Datei war ungültig',
      lock: 'Sperren',
      unlock: 'Unlock',
      budgetHistory: 'Budgetverlauf',
      totalInvoiced: 'Rechnungen',
      month: 'Monat',
      filterDocumentsPerMonth: 'Filtern Sie Dokumente pro Monat',
      filter: 'Filtern',
      cancel: 'Stornieren',
      personnel_locked: 'Das Budget für Personal wurde vom Administrator geschlossen. Es muss vom Administrator genehmigt werden, bevor Sie es verwenden können.',
      material_locked: 'Das Budget für Material wurde vom Administrator geschlossen. Es muss vom Administrator genehmigt werden, bevor Sie es verwenden können..',
      foreign_power_locked: 'Das Budget für den Auslandsdienst wurde vom Administrator geschlossen. Es muss vom Administrator genehmigt werden, bevor Sie es verwenden können.',
      inventory_locked: 'Das Budget für das Inventar wurde vom Administrator geschlossen. Es muss vom Administrator genehmigt werden, bevor Sie es verwenden können.',
      additional_costs_locked: 'Das Budget für zusätzliche Kosten wurde vom Administrator geschlossen. Es muss vom Administrator genehmigt werden, bevor Sie es verwenden können.',
      approveUsingOf: 'Sind Sie sicher, dass Sie die Verwendung von genehmigen möchten',
      forbidUsingOf: 'Sind Sie sicher, dass Sie die Verwendung von verbieten möchten',
      provideCorrectFormat: 'Bitte geben Sie das Bild im richtigen JPG- oder PNG-Format an.',
      requestAdditionalBudget: 'Fordern Sie zusätzliches Budget an',
      additionalBudgetSuccessfullyRequested: 'Sie haben erfolgreich eine Anfrage für ein zusätzliches Budget gestellt. Sie werden benachrichtigt, wenn der Administrator Ihre Anfrage bearbeitet.',
      additionalBudgetAllowed: 'Additional budget allowed',
      lockAllBudget: 'Sperren Sie das gesamte Budget',
      unlockAllBudget: 'Schalte das ganze Budget frei',
      youAreNotAble: 'Sie können keine zusätzlichen Kategorien hinzufügen, wenn der Administrator dies nicht zugelassen hat.',
      theBudgetIsLocked: 'Das Budget ist gesperrt.',
      areSureConfirmBudget: 'Sind Sie sicher, dass Sie das Budget bestätigen und den Administrator benachrichtigen möchten?',
      areYouSureLock: 'Möchten Sie wirklich alle Felder sperren und den Benutzer informieren?',
      areYouSureUnlock: 'Möchten Sie wirklich alle Felder entsperren und den Benutzer informieren?',
      adminClosedBudget: 'Der Administrator hat Ihr Budget geschlossen.',
      adminOpenedBudget: 'Der Administrator hat Ihr Budget geöffnet.',
      updateCategoryName: 'Kategorienamen aktualisieren',
      importCategories: 'Kategorien importieren',
      personnel: 'Personal',
      selectedCategories: 'Ausgewählte Kategorien',
      import: 'Import',
      selectProject: 'Projekt auswählen',
      filterCraftsmen: 'Filter Handwerker',
      addBudgetFirst: 'Sie müssen das Budget hinzufügen, bevor Sie bestätigen, dass es fertig ist.',
      documentSuccesfullyRemoved: 'Dokument erfolgreich entfernt.',
      areYouSureRemove: 'Möchten Sie das ausgewählte Dokument wirklich löschen?',
      invoiceLineAdded: 'Rechnungszeile erfolgreich hinzugefügt.',
      oopsSomethingWentWrong: 'Ooops! Etwas ist schief gelaufen.',
      afterClickingPlsCheck: 'Nachdem Sie auf das angeforderte Dokument geklickt haben, überprüfen Sie bitte andere Registerkarten oder Download-Ordner Ihres Browsers.',
      noCategoriesToImport: 'Keine zu importierenden Kategorien.',
      contractNumber: 'Vertragsnummer',
      budgetDone: 'Budget fertig',
      inputAdditionalBudget: 'Sie müssen die Summe für das zusätzliche Budget eingeben.',
      hasRequestedAdditionalBudget: 'hat ein zusätzliches Budget von angefordert',
      notifications: 'Benachrichtigungen',
      new: 'Neu',
      clearAll: 'Alles löschen',
      done: 'Getan',
      tasks: 'Aufgaben',
      bkp: 'BKP',
      listOfBkp: 'List der BKP',
      selectBkp: 'BKP auswählen',
      backToTasks: 'Zurück zu den Aufgaben',
      approve: 'Genehmigen',
      deny: 'Verweigern',
      areYouSureThatYouWantToApprove: 'Sind Sie sicher, dass Sie zusätzliches Budget für genehmigen möchten',
      areYouSureThatYouWantToDeny: 'Sind Sie sicher, dass Sie zusätzliches Budget für verweigern möchten',
      adminApprovedAdditionalBudget: 'Der Administrator hat ein zusätzliches Budget für Ihr Konto genehmigt',
      adminDeniedAdditionalBudget: 'Der Administrator hat Ihre Anfrage nach zusätzlichem Budget abgelehnt',
      noNewTasks: 'Keine neuen Aufgaben',
      noDoneTasks: 'Keine erledigten Aufgaben',
      additionalBudgetHistory: 'Zusätzliche Budgethistorie',
      addNewBkp: 'Neues BKP hinzufügen',
      theNameOfBkp: 'BKP Nummer',
      updateContract: 'Vertrag aktualisieren',
      updateContractNumber: 'Vertragsnummer aktualisieren',
      contractNoSuccesfullyUpdated: 'Vertragsnummer erfolgreich aktualisiert.',
      ensureThisValueIsGreaterThanOrEqualTo001: 'Bitte stellen Sie sicher, dass dieser Wert größer als 0 ist.',
      planner: 'Planer',
      descriptionInvoiceNumber: 'Beschreibung (Rechnungsnummer)',
      amountChfExclVat: 'Betrag (CHF ohne MwSt.)',
      bkpDescription: 'BKP Bezeichnung',
      updateBkp: 'Aktualisieren Sie BKP',
      searchForCraftsmenByBKP: 'Suche nach Handwerkern von BKP',
      searchBy: 'Suche nach ',
      areYouSureDeleteBudget: 'Möchten Sie dieses zusätzliche Budget wirklich löschen?',
      additionalBudgetSuccesfullyRemoved: 'Zusätzliches Budget erfolgreich entfernt.',
      projectController: 'Projektmanager',
      plsSelectOne: 'Bitte wählen Sie eine aus',
      plsSetYourStaticBudget: 'Bitte legen Sie das statische Budget für Ihren Vertrag fest.',
      createdBy: 'Projektmanager',
      lockStaticBudget: 'Vertragsbudget sperren',
      addUpdateProjectColor: 'Projektfarbe hinzufügen / aktualisieren',
      updateProjectColor: 'Projektfarbe aktualisieren',
      mustSelectBKP: 'Sie müssen BKP auswählen, bevor Sie dem Projekt Handwerker hinzufügen.',
      addAdditionalBudget: 'Fügen Sie zusätzliches Budget hinzu',
      additionalBudgetSuccessfullyAdded: 'Zusätzliches Budget erfolgreich hinzugefügt.',
      serialNumber: 'Laufnummer',
      offerNumber: 'Angebotsnummer',
      forMonth: 'Für einen Monat',
      allAdditionalBudgetsSuccessfullyAdded: 'Alle zusätzlichen Budgets wurden erfolgreich hinzugefügt.',
      companies: 'Firmen',
      listOfCompanies: 'Liste der Unternehmen',
      addNewCompany: 'Neue Firma hinzufügen',
      companySuccessfullyCreated: 'Firma erfolgreich erstellt',
      updateCompany: 'Firma aktualisieren',
      companySuccessfullyUpdated: 'Firma erfolgreich aktualisiert.',
      removeAdditionalBudget: 'Zusätzliches Budget entfernen',
      saveAdditionalBudget: 'Speichern Sie zusätzliches Budget',
      areYouSureYouWantAddUser: 'Sind Sie sicher, dass Sie Benutzer mit folgenden Daten zum Projekt hinzufügen möchten?',
      setContractNumber: 'Vertragsnummer einstellen',
      contractNumberIsMandatoryField: 'Die Vertragsnummer ist ein Pflichtfeld.',
      endDateOfSheetIsOutOfRangeOfProject: 'Das Enddatum des Blattes liegt außerhalb des Projektbereichs.',
      badRequest: 'Ungültige Anforderung',
      descriptionOrOfferNumberOrAdditionalBudgetDataNotCorrect: 'Beschreibung oder Angebotsnummer oder zusätzliche Budgetdaten nicht korrekt.',
      setStaticBudget: 'Legen Sie das statische Budget fest',
      staticBudgetPlusAdditionalBudget: 'Statisches Budget + Zusätzliches Budget (e)',
      data: 'Daten',
      additionalBudget:'Zusätzliches Budget',
      settings: 'Einstellungen',
      addUpdateAppLogo: 'Anwendungslogo hinzufügen / aktualisieren',
      addUpdateTabText: 'Registerkarte-Text hinzufügen / aktualisieren',
      appDetailsUpdated: 'Anwendungsdetails erfolgreich aktualisiert.',
      features: 'EIGENSCHAFTEN',
      reporting: 'Berichterstattung',
      dynamicBudgetUpToCurrentMonth: 'Dynamisches Budget bis zum laufenden Monat',
      actualCostsUpToCurrentMonth: 'Tatsächliche Kosten bis zum laufenden Monat',
      dataTable: 'Datentabelle',
      deviation: 'Abweichung',
      showHide: 'Anzeigen Ausblenden',
      show: 'Anzeigen',
      hide: 'Ausblenden',
      informAutomaticContractNumber: 'Bitte beachten Sie auch, dass das Feld für die Vertragsnummer leer war und automatisch festgelegt wurde.',
      rest: 'derRest',
      errors: 'Fehler',
      notes: 'Notizen',
      updateNotes: 'Notizen aktualisieren',
      addaNewNote: 'Fügen Sie eine neue Notiz hinzu',
      text: 'Notizen Text',
      succesfullyAdded: 'Erfolgreich hinzugefügt',
      note: 'Notiz',
      this: 'diese',
      succesfullyDeleted: 'erfolgreich gelöscht',
      goToLockMonths: 'Monate sperren',
      lockMonths: 'Monate sperren',
      messaging: 'Nachrichten',
      subject: 'Gegenstand',
      messageBody: 'Nachrichtentext',
      send: 'Senden',
      emailArchive: 'E-Mail-Archiv',
      sendEmailAlerts: 'Senden Sie E-Mail-Benachrichtigungen',
      closeSheet: 'Blatt schließen',
      areYouSureDeleteCategory: 'Möchten Sie diese Kategorie wirklich löschen?',
      category: 'Kategorie',
      pleaseNoteCostsAlso: 'Bitte beachten Sie, dass alle mit dieser Kategorie verbundenen Kosten ebenfalls gelöscht werden.',
      goToTaskHistory: 'Gehen Sie zum Aufgabenverlauf',
      taskHistory: 'Aufgabenverlauf',
      details: 'Einzelheiten',
      created: 'Erstellt',
      approveadditionalbudget: 'Zusätzliches Budget genehmigen',
      admin: 'Administrator',
      issuedBy: 'Herausgegeben von',
      showMoreRows: 'Weitere Zeilen anzeigen',
      closedByAdministrator: 'Vom Administrator geschlossen',
      lateWithInput: 'Fehlende Eingaben Vormonat',
      lateWithInputCurrentMonth: 'Fehlende Eingaben aktueller Monat',
      zeroValueAdded: 'Aktueller Monat ohne Kosten',
      sheetClosed: 'Blatt geschlossen',
      costsAdded: 'Kosten hinzugefügt',
      dashboardVisibleForCraftsmen: 'Dashboard für Handwerker / Planner sichtbar',
      yourContracts: 'Ihre Verträge',
      listOfWork: 'Liste Gewerke',
      addNewWork: 'Neues Gewerk hinzufügen',
      updateWork: 'Aktualisieren Sie Gewerk',
      theNameOfWork: 'Gewerk Nummer',
      workDescription: 'Gewerk Bezeichnung',
      clickToAddCosts: 'Klicken Sie hier, um Kosten hinzuzufügen',
      selectWork: 'Select Gewerk',
      job: 'Arbeit',
      distributionActuals: 'Verteilung der tatsächlichen Kosten',
      distributionBudget: 'Verteilung der Budgetkosten',
      documents: 'Dokumente',
      createArchive: 'Archiv erstellen',
      invoice: 'Rechnungen',
      offer: 'Angebote',
      action: 'Aktion',
      filterByCategory: 'Nach Kategorie filtern',
      archiveZipFile: 'Die Zip-Datei des Archivs wird generiert. In ein paar Minuten bitte besuchen',
      listArchivesCreated: 'Liste der erstellten Archive',
      creationCompleted: 'Liste der erstellten Archive',
      completed: 'Abgeschlossen',
      notCompleted: 'Nicht vollständig',
      emailAlertSettingChangedSuccesfully: 'Die Einstellung für die E-Mail-Benachrichtigung wurde erfolgreich geändert.'
    }
  },
  fr: {
    message: {
      logIn: 'S\'identifier',
      signUp: 'S\'inscrire',
      signOut: 'Déconnexion',
      logOut: 'Se déconnecter',
      email: 'Email',
      password: 'Mot de passe',
      rememberMe: 'Souviens-toi de moi',
      forgotPassword: 'Mot de passe oublié?',
      invalidCredentials: 'Les informations d\'identification invalides.',
      accountNotActive: 'Compte non actif.',
      profile: 'Profil',
      info: 'Info',
      changePassword: 'Changer le mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      companyName: 'Nom de la compagnie',
      companyWebsite: 'Site Web d\'entreprise',
      resetPasswordSuccess: 'Votre mot de passe a été réinitialisé avec succès.',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      repeatNewPassword: 'Répété le nouveau mot de passe',
      city: 'Ville',
      street: 'Rue',
      state: 'Canton',
      country: 'la Patrie',
      zipCode: 'Code postal',
      streetNr: 'Numéro de rue',
      update: 'Réactualiser',
      resetPassword: 'Réinitialiser le mot de passe',
      sendEmail: 'Envoyer un email',
      emailNotFound: 'L\'email que vous avez fourni n\'existe pas dans la base de données.',
      resetLink: 'Un lien permettant de réinitialiser le mot de passe a été envoyé par email que vous avez fourni.',
      passwordMinLen: 'Le mot de passe doit comporter au moins 8 caractères.',
      passwordsMatch: 'Les mots de passe doivent correspondre.',
      tokenExpired: 'Le token pour l\'activation du compte est invalide ou a expiré.',
      jobs: 'Travails',
      listOfJobs: 'Liste d\'travail',
      addNewJob: 'Ajouter un nouveau travail',
      theNameOfTheJob: 'Le nom du travail',
      add: 'Ajouter',
      contacts: 'Contacts',
      listOfContacts: 'Liste des contacts',
      addNewContact: 'Ajouter un nouveau contact',
      jobCreatedSuccessfully: 'BKP créé avec succès',
      jobsWithThisNameAlreadyExists: 'Le travail avec le nom fourni existe déjà.',
      thisFieldMayNotBeNull: 'Vous devez définir une valeur pour ce champ.',
      thisFieldMayNotBeBlank: 'Vous avez entré une valeur vide dans ce champ.',
      activateAccount: 'Veuillez changer le mot de passe par défaut. Vous pouvez le modifier dans le formulaire de changement de profil / mot de passe.',
      changedPassword: 'Vous avez changé votre mot de passe avec succès.',
      wrongCurrentPassword: 'Mot de passe actuel incorrect.',
      ensureThisFieldHasAtLeast8Characters: 'Courant incorrect Ce champ doit contenir au moins 8 caractères.',
      yes: 'Oui',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ',
      updateJob: 'Mettre à jour le travail',
      jobUpdatedSuccessfully: 'BKP mis à jour avec succès.',
      profileUpdated: 'Mise à jour du profil réussie.',
      providePhoneType: 'Vous devez sélectionner le type de téléphone.',
      providePhoneNumber: 'Vous devez fournir un numéro de téléphone.',
      phones: 'Téléphones',
      addPhones: 'Ajouter des téléphones',
      number: 'Nombre',
      noPhones: 'Pas de téléphone.',
      privateMobile: 'Téléphone portable privé',
      businessMobile: 'Téléphone de travail',
      home: 'Accueil',
      business: 'Entreprise',
      other: 'Autre',
      projects: 'Projets',
      dashboard: 'Dashboard',
      noResults: 'Aucun résultat trouvé.',
      selectJobs: 'Sélectionnez les travaux.',
      typeToSearch: 'Tapez pour rechercher',
      contactSuccessfullyAdded: 'areYouSureYouWantAddUserContact ajouté avec succès.',
      craftsman: 'Artisan',
      manager: 'Directeur',
      isManager: 'Artisan',
      isCraftsman: 'Directeur',
      userWithProvidedEmailAlreadyExists: 'L\'utilisateur avec l\'e-mail fourni existe déjà.',
      userSuccessfullyCreated: 'L\'utilisateur a été créé avec succès.',
      userSuccessfullyUpdated: 'L\'utilisateur a été mis à jour avec succès.',
      updateContact: 'Mettre à jour le contact',
      enterAValidEmailAddress: 'Entrez une adresse mail valide.',
      selectContactType: 'Sélectionnez le type de contact',
      filterContacts: 'Filtrer les contacts',
      addProject: 'Ajouter un nouveau projet',
      editProject: 'Modifier le projet',
      projectName: 'Nom du projet',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      description: 'La description',
      targetCost: 'Coût cible',
      staticBudget: 'Budget statique',
      projectCreatedSuccessfully: 'Projet créé avec succès.',
      name: 'Nom',
      dateHasWrongFormatUseOneOfTheseFormatsInsteadYyyymmdd: 'La date a un format incorrect',
      aValidNumberIsRequired: 'Un numéro valide est requis.',
      thisOperationCanNotBeUndone: 'Cette opération ne peut pas être annulée!',
      projectUpdatedSuccessfully: 'Projet mis à jour avec succès.',
      noProjects: 'Pas de projets',
      selectImage: 'Sélectionner une image',
      upload: 'Télécharger',
      addUpdateCoverImage: 'Ajouter / mettre à jour l\'image de couverture',
      coverImage: 'Image de couverture',
      basicInfo: 'informations de base',
      confirmRemove: 'Voulez-vous vraiment supprimer',
      noStartDate: 'Pas de date de début',
      noEndDate: 'Pas de date de fin',
      userWithThisEmailAlreadyExists: 'Utilisateur avec cet emial existe déjà',
      fromTheProject: 'du projet',
      jobTypeOnProject: 'Type de travail sur le projet en cours',
      status: 'Statut',
      active: 'Actif',
      notActive: 'Pas actif',
      noJobSelected: 'Type de travail non sélectionné',
      user: 'Utilisateur',
      withJob: 'avec travail',
      isAlreadyOnProject: 'est déjà sur le projet',
      addCraftsmenToProject: 'Ajoutez des artisans au projet',
      searchForCraftsmenByCompanyName: 'Recherche d\'artisans par nom d\'entreprise',
      selectCraftsmen: 'Sélectionner des artisans dans la liste pour ajouter au projet',
      currentJobType: 'Type d\'emploi actuel',
      listOfUsersActiveOnProject: 'Liste des artisans actuellement actifs sur le projet',
      successfullyAddedToProject: 'ajouté au projet avec succès',
      projectStatus: 'L\'état du projet',
      pageNotFound: 'Désolé, la page que vous avez demandée est introuvable',
      ensureThisValueIsGreaterThanOrEqualTo00: 'Assurez-vous que cette valeur est supérieure ou égale à 0',
      startDateLater: 'La date de début doit être antérieure à la date de fin.',
      categoriesPersonnel: 'Catégories personnel',
      chfPerHour: 'CHF par heure',
      addCategoriesPersonnel: 'Ajouter des catégories de personnel',
      value: 'Valeur',
      material: 'Matière',
      surcharge: 'Surtaxe',
      foreignService: 'Service extérieur',
      inventory: 'Inventaire',
      amount: 'Montant',
      additionalCosts: 'Coûts supplémentaires',
      addCostCategories: 'Ajouter des catégories de coûts',
      currentDate: 'Date courante',
      dateLastFriday: 'Vendredi dernier',
      addCategoriesMaterial: 'Ajouter des catégories de matériaux',
      addCategoriesForeignService: 'Ajouter des catégories de services étrangers',
      addCategoriesInventory: 'Ajouter des catégories d\'inventaire',
      addCategoriesAdditionalCosts: 'Ajouter des catégories de coûts supplémentaires',
      thisFieldIsRequired: 'Ce champ est requis',
      actualCosts: 'Coûts réels',
      budget: 'Budget',
      summary: 'Synopse',
      work: 'Travail',
      date: 'Date',
      amountOfHours: 'Nombre d\'heures',
      total: 'Total',
      costs: 'Frais',
      unit: 'Unité',
      costsUpdated: 'Coûts mis à jour avec succès',
      orderByStartDate: 'Ordonner par date de début',
      selectCategoryForSorting: 'Sélectionnez une catégorie pour le tri',
      yourParticipationOnProject: 'Votre participation au projet',
      yourParticipationStarts: 'Votre participation commence',
      yourParticipationEnds: 'Votre participation se termine',
      pleaseCreateCategory: 'Veuillez créer au moins une catégorie de coûts avant de procéder à l\'ajout de lignes.',
      dynamicBudget: 'Budget dynamique',
      updateOverallDetails: 'Mettre à jour les détails généraux',
      addRowWithNewDate: 'Ajouter une ligne avec une nouvelle date',
      sheetSuccesfullyUpdated: 'Les détails de votre tâche ont été mis à jour avec succès.',
      projectsWithThisNameAlreadyExists: 'Le projet portant ce nom existe déjà.',
      preferredLanguage: 'Langue préférée',
      filterProjects: 'Filtrer les projets',
      addAnotherCostLine: 'Ajouter une autre ligne de coût pour la même date',
      removeCostLine: 'Supprimer la ligne de coût',
      addACategory: 'Ajouter une catégorie',
      deviationFromTargetCosts: 'Écart par rapport aux coûts cibles',
      deviationFromBudget: 'Écart par rapport au budget',
      overallProjectData: 'Données globales du projet',
      downloadToCsv: 'Télécharger le rapport CSV',
      notPossibleToCalculate: 'Impossible de calculer',
      deleteCostRow: 'Voulez-vous vraiment supprimer la ligne? Il a déjà été enregistré dans la base de données',
      backToProjectPage: 'Retour à la page du projet',
      backToDashboard: 'Retour au Dashboard',
      leavePage: 'Voulez-vous vraiment quitter la page? Vous avez des changements non enregistrés!',
      deleteRowNotAllowed: 'Vous ne pouvez pas supprimer cette ligne, il doit y en avoir une pour chaque mois. S\'il n\'y a pas eu de dépenses, laissez des zéros.',
      addUpdateProfileImage: 'Ajouter / mettre à jour l\'image de profil en un clic',
      coverImageSuccesfullyUpdated: 'Image de couverture mise à jour avec succès.',
      addUpdate: 'Ajouter / mettre à jour',
      rollingForecast: 'Prévisions glissantes',
      costsAndDates: ' coûts et dates',
      setStartDateFor: 'Définir la date de début pour ',
      taskOnTheProject: ' tâche sur le projet',
      price: 'Prix',
      nonFieldErrors: 'Autres erreurs',
      passwordNotComplex: 'Veuillez saisir un mot de passe d\'au moins 8 caractères, avec au moins 1 caractère minuscule, 1 caractère majuscule et au moins 1 chiffre.',
      dateOutOfRange: 'La date sélectionnée doit être comprise entre la date de début et la date de fin du projet',
      youHaveToProvideStartDate: 'Vous devez fournir une date de début pour le travail d\'artisan sur le projet.',
      totalCostsProjectLeader: 'Chef de projet coûts totaux',
      addDocument: 'Ajouter un document',
      chooseFile: 'Choisissez un fichier',
      documentSuccesfullyUploaded: 'Document(s) téléchargé avec succès.',
      listAlreadyAdded: 'Liste des documents déjà ajoutés',
      renameUploadedFile: 'Veuillez renommer le fichier pour qu\'il ne contienne pas d\'espace blanc.',
      companyAbbreviation: 'Abréviation de l\'entreprise',
      invoiced: 'Facturé',
      file: 'Fichier',
      theSubmittedDataWasNotAFileCheckTheEncodingTypeOnTheForm: 'Le fichier soumis n\'est pas valide',
      lock: 'Serrure',
      unlock: 'Unlock',
      budgetHistory: 'Historique budgétaire',
      totalInvoiced: 'Total facturé',
      month: 'Mois',
      filterDocumentsPerMonth: 'Filtrer les documents par mois',
      filter: 'Filtrer',
      cancel: 'Annuler',
      personnel_locked: 'L\'administrateur a clôturé le budget du personnel. Il devra être approuvé par l\'administrateur avant de pouvoir commencer à l\'utiliser.',
      material_locked: 'Le budget du matériel a été clôturé par l\'administrateur. Il devra être approuvé par l\'administrateur avant de pouvoir commencer à l\'utiliser.',
      foreign_power_locked: 'L\'administrateur a clôturé le budget du service extérieur. Il devra être approuvé par l\'administrateur avant de pouvoir commencer à l\'utiliser.',
      inventory_locked: 'L\'administrateur a clôturé le budget pour l\'inventaire. Il devra être approuvé par l\'administrateur avant de pouvoir commencer à l\'utiliser.',
      additional_costs_locked: 'L\'administrateur a clôturé le budget des coûts supplémentaires. Il devra être approuvé par l\'administrateur avant de pouvoir commencer à l\'utiliser.',
      approveUsingOf: 'Voulez-vous vraiment approuver l\'utilisation de',
      forbidUsingOf: 'Voulez-vous vraiment interdire l\'utilisation de',
      provideCorrectFormat: 'Veuillez fournir l\'image au format jpg ou png correct.',
      requestAdditionalBudget: 'Demander un budget supplémentaire',
      additionalBudgetSuccessfullyRequested: 'Vous avez correctement publié une demande de budget supplémentaire. Vous serez averti lorsque l\'administrateur traitera votre demande.',
      additionalBudgetAllowed: 'Additional budget allowed',
      lockAllBudget: 'Verrouiller tout le budget',
      unlockAllBudget: 'Débloquer tout le budget',
      youAreNotAble: 'Vous ne pouvez pas ajouter de catégories supplémentaires si l\'administrateur ne l\'a pas autorisé.',
      theBudgetIsLocked: 'Le budget est verrouillé.',
      areSureConfirmBudget: 'Voulez-vous vraiment confirmer le budget et en informer l\'administrateur?',
      areYouSureLock: 'Voulez-vous vraiment verrouiller tous les champs et informer l\'utilisateur?',
      areYouSureUnlock: 'Voulez-vous vraiment déverrouiller tous les champs et informer l\'utilisateur?',
      adminClosedBudget: 'L\'administrateur a clôturé votre budget.',
      adminOpenedBudget: 'L\'administrateur a ouvert votre budget.',
      updateCategoryName: 'Mettre à jour le nom de la catégorie',
      importCategories: 'Catégories d\'importation',
      personnel: 'Personnel',
      selectedCategories: 'Catégories sélectionnées',
      import: 'Import',
      selectProject: 'Sélectionnez un projet',
      filterCraftsmen: 'Filtrer les artisans',
      addBudgetFirst: 'Vous devez ajouter un budget avant de confirmer que c\'est fait.',
      documentSuccesfullyRemoved: 'Document supprimé avec succès.',
      areYouSureRemove: 'Voulez-vous vraiment supprimer le document sélectionné?',
      invoiceLineAdded: 'La ligne de facture a bien été ajoutée.',
      oopsSomethingWentWrong: 'Oups! Quelque chose a mal tourné.',
      afterClickingPlsCheck: 'Après avoir cliqué sur le document demandé, veuillez vérifier les autres onglets ou le dossier de téléchargements de votre navigateur.',
      noCategoriesToImport: 'Aucune catégorie à importer.',
      contractNumber: 'Numéro de contrat',
      budgetDone: 'Budget fait',
      inputAdditionalBudget: 'Vous devez saisir la somme pour le budget supplémentaire.',
      hasRequestedAdditionalBudget: 'a demandé un budget supplémentaire de',
      notifications: 'Notifications',
      new: 'Nouveau',
      clearAll: 'Tout effacer',
      done: 'Terminé',
      tasks: 'Tâches',
      bkp: 'BKP',
      listOfBkp: 'Liste des BKP',
      selectBkp: 'Sélectionnez BKP',
      backToTasks: 'Retour aux tâches',
      approve: 'Approuver',
      deny: 'Nier',
      areYouSureThatYouWantToApprove: 'Voulez-vous vraiment approuver un budget supplémentaire pour',
      areYouSureThatYouWantToDeny: 'Voulez-vous vraiment refuser un budget supplémentaire pour',
      adminApprovedAdditionalBudget: 'L\'administrateur a approuvé un budget supplémentaire sur votre compte',
      adminDeniedAdditionalBudget: 'L\'administrateur a refusé votre demande de budget supplémentaire',
      noNewTasks: 'Aucune nouvelle tâche',
      noDoneTasks: 'Aucune tâche terminée',
      additionalBudgetHistory: 'Historique budgétaire supplémentaire',
      addNewBkp: 'Ajouter un nouveau BKP',
      theNameOfBkp: 'Le nom de BKP',
      updateContract: 'Mettre à jour le contrat',
      updateContractNumber: 'Mettre à jour le numéro de contrat',
      contractNoSuccesfullyUpdated: 'Numéro de contrat mis à jour avec succès.',
      ensureThisValueIsGreaterThanOrEqualTo001: 'Veuillez vous assurer que cette valeur est supérieure à 0.',
      planner: 'Planificateur',
      descriptionInvoiceNumber: 'Descrizione (numero fattura)',
      amountChfExclVat: 'Montant (CHF hors TVA)',
      bkpDescription: 'Description de BKP',
      updateBkp: 'Mettre à jour BKP',
      searchForCraftsmenByBKP: 'Recherche d\'artisans par BKP',
      searchBy: 'Recherché par ',
      areYouSureDeleteBudget: 'Voulez-vous vraiment supprimer ce budget supplémentaire?',
      additionalBudgetSuccesfullyRemoved: 'Budget supplémentaire supprimé avec succès.',
      projectController: 'Contrôleur de projet',
      plsSelectOne: 'S\'il vous plait sélectionner en un',
      plsSetYourStaticBudget: 'Veuillez définir le budget statique de votre contrat.',
      createdBy: 'Contrôleur de projet',
      lockStaticBudget: 'Verrouiller le budget statique',
      addUpdateProjectColor: 'Ajouter / mettre à jour la couleur du projet',
      updateProjectColor: 'Mettre à jour la couleur du projet',
      mustSelectBKP: 'Vous devez sélectionner BKP avant d\'ajouter des artisans au projet.',
      addAdditionalBudget: 'Ajouter un budget supplémentaire',
      additionalBudgetSuccessfullyAdded: 'Budget supplémentaire ajouté avec succès.',
      serialNumber: 'Numéro de série',
      offerNumber: 'Numéro de l\'offre',
      forMonth: 'Pour mois',
      allAdditionalBudgetsSuccessfullyAdded: 'Tous les budgets supplémentaires ont été ajoutés avec succès.',
      companies: 'Entreprises',
      listOfCompanies: 'Liste d\'entreprises',
      addNewCompany: 'Ajouter une nouvelle entreprise',
      companySuccessfullyCreated: 'Création réussie de l\'entreprise',
      updateCompany: 'Mettre à jour l\'entreprise',
      companySuccessfullyUpdated: 'Entreprise mise à jour avec succès.',
      removeAdditionalBudget: 'Supprimer le budget supplémentaire',
      saveAdditionalBudget: 'Enregistrer du budget supplémentaire',
      areYouSureYouWantAddUser: 'Êtes-vous sûr de vouloir ajouter un utilisateur avec les données suivantes au projet?',
      setContractNumber: 'Définir le numéro de contrat',
      contractNumberIsMandatoryField: 'Le numéro de contrat est un champ obligatoire.',
      endDateOfSheetIsOutOfRangeOfProject: 'la date de fin de la feuille est hors de portée du projet.',
      badRequest: 'Mauvaise Demande',
      descriptionOrOfferNumberOrAdditionalBudgetDataNotCorrect: 'description ou numéro d\'offre ou données budgétaires supplémentaires non corrects.',
      setStaticBudget: 'Définir un budget statique',
      staticBudgetPlusAdditionalBudget: 'Budget statique + budget (s) supplémentaire (s)',
      data: 'Les données',
      additionalBudget: 'Budget supplémentaire',
      settings: 'Paramètres',
      addUpdateAppLogo: 'Ajouter / mettre à jour le logo de l\'application',
      addUpdateTabText: 'Ajouter / mettre à jour le texte de l\'onglet',
      appDetailsUpdated: 'Détails de l\'application mis à jour avec succès.',
      features: 'FONCTIONNALITÉS',
      reporting: 'Rapports',
      dynamicBudgetUpToCurrentMonth: 'Budget dynamique jusqu\'au mois en cours',
      actualCostsUpToCurrentMonth: 'Coûts réels jusqu\'au mois en cours',
      dataTable: 'Tableau de données',
      deviation: 'Déviation',
      showHide: 'Afficher / masquer',
      show: 'Afficher',
      hide: 'Masquer',
      informAutomaticContractNumber: 'Veuillez également noter que le champ du numéro de contrat était vide et qu\'il a été défini automatiquement.',
      rest: 'du repos',
      errors: 'Les erreurs',
      notes: 'Remarques',
      updateNotes: 'Mettre à jour les notes',
      addaNewNote: 'Ajouter une nouvelle note',
      text: 'Texte des notes',
      succesfullyAdded: 'ajouté avec succès',
      note: 'Note',
      this: 'cette',
      succesfullyDeleted: 'supprimé avec succès',
      goToLockMonths: 'Aller à verrouiller les mois',
      lockMonths: 'Verrouiller les mois',
      messaging: 'Messagerie',
      subject: 'Matière',
      messageBody: 'Corps du message',
      send: 'Envoyer',
      emailArchive: 'Archive des e-mails',
      sendEmailAlerts: 'Envoyer des alertes par e-mail',
      closeSheet: 'Fermer la feuille',
      areYouSureDeleteCategory: 'Êtes-vous sûr de vouloir supprimer cette catégorie?',
      category: 'Catégorie',
      pleaseNoteCostsAlso: 'Veuillez noter que tous les coûts liés à cette catégorie seront également supprimés.',
      goToTaskHistory: 'Aller à l\'historique des tâches',
      taskHistory: 'Historique des tâches',
      details: 'Détails',
      created: 'Créée',
      approveadditionalbudget: 'Approuver le budget supplémentaire',
      admin: 'Administrateur',
      issuedBy: 'Délivré par',
      showMoreRows: 'Afficher plus de lignes',
      closedByAdministrator: 'Fermé par l\'administrateur',
      lateWithInput: 'Entrées manquantes le mois précédent',
      lateWithInputCurrentMonth: 'Entrées manquantes pour le mois en cours',
      zeroValueAdded: 'Entrées manquantes pour le mois en cours',
      sheetClosed: 'Feuille fermée',
      costsAdded: 'Coûts ajoutés',
      dashboardVisibleForCraftsmen: 'Tableau de bord visible pour les artisans / planificateurs',
      yourContracts: 'Vos contrats',
      listOfWork: 'Liste des travaux',
      addNewWork: 'Ajouter un nouveau travail',
      updateWork: 'Mettre à jour le travail',
      theNameOfWork: 'Numéro de travail',
      workDescription: 'Description du travail',
      clickToAddCosts: 'Cliquez pour ajouter des coûts',
      selectWork: 'Sélectionnez le travail',
      job: 'Emploi',
      distributionActuals: 'Répartition des coûts réels',
      distributionBudget: 'Répartition des coûts budgétaires',
      documents: 'Des documents',
      createArchive: 'Créer une archive',
      invoice: 'Facture d\'achat',
      offer: 'Offre',
      action: 'Action',
      filterByCategory: 'Filtrer par catégorie',
      archiveZipFile: 'Le fichier zip d\'archive est en cours de génération. Dans quelques minutes, veuillez visiter',
      listArchivesCreated: 'Liste des archives créées',
      creationCompleted: 'Liste des archives créées',
      completed: 'Terminé',
      notCompleted: 'Pas achevé',
      emailAlertSettingChangedSuccesfully: 'Le paramètre d\'alerte par e-mail a bien été modifié.'
    }
  },
  it: {
    message: {
      logIn: 'Accesso',
      signUp: 'Iscriviti',
      signOut: 'Disconnessione',
      logOut: 'Disconnettersi',
      email: 'E-mail',
      password: 'Parola d\'ordine',
      rememberMe: 'Ricordati di me',
      forgotPassword: 'Ha dimenticato la password?',
      invalidCredentials: 'Credenziali non valide.',
      accountNotActive: 'Account non attivo.',
      profile: 'Profilo',
      info: 'Informazioni',
      changePassword: 'Cambia la password',
      firstName: 'Nome di battesimo',
      lastName: 'Cognome',
      companyName: 'Nome della ditta',
      companyWebsite: 'Sito web aziendale',
      resetPasswordSuccess: 'La tua password è stata ripristinata correttamente.',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova password',
      repeatNewPassword: 'Ripetere la nuova password',
      city: 'Città',
      street: 'Strada',
      state: 'Cantone',
      country: 'Nazione',
      zipCode: 'Cap',
      streetNr: 'Numero civico',
      update: 'Aggiornare',
      resetPassword: 'Resetta la password',
      sendEmail: 'Invia una email',
      emailNotFound: 'L\'email fornita non esiste nel database.',
      resetLink: 'Il link per reimpostare la password è stato inviato all\'email che hai fornito.',
      passwordMinLen: 'La password deve contenere almeno 8 caratteri.',
      passwordsMatch: 'Le password devono essere identiche.',
      tokenExpired: 'Il token per l\'attivazione dell\'account non è valido o è scaduto.',
      jobs: 'Lavori',
      listOfJobs: 'Elenco dei lavori',
      addNewJob: 'Aggiungi un nuovo lavoro',
      theNameOfTheJob: 'Il nome del lavoro',
      add: 'Inserisci',
      contacts: 'Contatti',
      listOfContacts: 'Elenco dei contatti',
      addNewContact: 'Aggiungi un nuovo contatto',
      jobCreatedSuccessfully: 'BKP creato con successo.',
      jobsWithThisNameAlreadyExists: 'Il processo con il nome fornito esiste già.',
      thisFieldMayNotBeNull: 'È necessario impostare un valore per questo campo.',
      thisFieldMayNotBeBlank: 'Hai inserito un valore vuoto in questo campo.',
      activateAccount: 'Modifica la password predefinita. È possibile modificarlo nel modulo di modifica profilo / password.',
      changedPassword: 'Hai cambiato con successo la tua password.',
      wrongCurrentPassword: 'Password corrente errata.',
      ensureThisFieldHasAtLeast8Characters: 'Corrente errata Questo campo deve contenere almeno 8 caratteri.',
      yes: 'Si',
      no: 'No',
      confirmDelete: 'Sei sicuro di voler eliminare ',
      updateJob: 'Aggiorna lavoro',
      jobUpdatedSuccessfully: 'BKP aggiornato correttamente.',
      profileUpdated: 'Profilo aggiornato con successo.',
      providePhoneType: 'Devi selezionare il tipo di telefono.',
      providePhoneNumber: 'Devi fornire il numero di telefono.',
      phones: 'Telefoni',
      addPhones: 'Aggiungi telefoni',
      number: 'Numero',
      noPhones: 'Nessun telefono.',
      privateMobile: 'Cellulare privato',
      businessMobile: 'Telefono aziendale',
      home: 'Casa',
      business: 'Attività commerciale',
      other: 'Altro',
      projects: 'Progetti',
      dashboard: 'Dashboard',
      noResults: 'Nessun risultato trovato.',
      selectJobs: 'Seleziona lavori.',
      typeToSearch: 'Digita per cercare',
      contactSuccessfullyAdded: 'Contatto aggiunto correttamente.',
      craftsman: 'Artigiano',
      manager: 'Manager',
      isManager: 'Artigiano',
      isCraftsman: 'Manager',
      userWithProvidedEmailAlreadyExists: 'L\'utente con l\'email fornita esiste già.',
      userSuccessfullyCreated: 'Utente creato correttamente.',
      userSuccessfullyUpdated: 'Utente aggiornato correttamente.',
      updateContact: 'Aggiorna contatto',
      enterAValidEmailAddress: 'Inserire un indirizzo email valido.',
      selectContactType: 'Seleziona il tipo di contatto',
      filterContacts: 'Filtra i contatti',
      addProject: 'Aggiungi nuovo progetto',
      editProject: 'Modifica progetto',
      projectName: 'Nome del progetto',
      startDate: 'Data d\'inizio',
      endDate: 'Data di fine',
      description: 'Descrizione',
      targetCost: 'Costo target',
      staticBudget: 'Bilancio statico',
      projectCreatedSuccessfully: 'Progetto creato con successo.',
      name: 'Nome',
      dateHasWrongFormatUseOneOfTheseFormatsInsteadYyyymmdd: 'La data ha un formato errato',
      aValidNumberIsRequired: 'È richiesto un numero valido.',
      thisOperationCanNotBeUndone: 'Questa operazione non può essere annullata!',
      projectUpdatedSuccessfully: 'Progetto aggiornato con successo.',
      noProjects: 'Nessun progetto',
      selectImage: 'Seleziona immagine',
      upload: 'Caricare',
      addUpdateCoverImage: 'Aggiungi / aggiorna l\'immagine di copertina',
      coverImage: 'Immagine di copertina',
      basicInfo: 'informazioni di base',
      confirmRemove: 'Sei sicuro di voler rimuovere',
      noStartDate: 'Nessuna data di inizio',
      noEndDate: 'Nessuna data di fine',
      userWithThisEmailAlreadyExists: 'L\'utente con questa e-mail esiste già',
      fromTheProject: 'dal progetto',
      jobTypeOnProject: 'Tipo di lavoro sul progetto corrente',
      status: 'Stato',
      active: 'Attivo',
      notActive: 'Non attivo',
      noJobSelected: 'Tipo di lavoro non selezionato',
      user: 'Utente',
      withJob: 'con lavoro',
      isAlreadyOnProject: 'è già sul progetto',
      addCraftsmenToProject: 'Aggiungi artigiani al progetto',
      searchForCraftsmenByCompanyName: 'Cerca artigiani per nome dell\'azienda',
      selectCraftsmen: 'Seleziona artigiani dall\'elenco da aggiungere al progetto',
      currentJobType: 'Tipo di lavoro corrente',
      listOfUsersActiveOnProject: 'Elenco degli artigiani attualmente attivi sul progetto',
      successfullyAddedToProject: 'aggiunto con successo al progetto',
      projectStatus: 'Stato del progetto',
      pageNotFound: 'Siamo spiacenti, la pagina richiesta non è stata trovata',
      ensureThisValueIsGreaterThanOrEqualTo00: 'Assicurarsi che questo valore sia maggiore o uguale a 0',
      startDateLater: 'La data di inizio deve essere precedente alla data di fine.',
      categoriesPersonnel: 'Personale delle categorie',
      chfPerHour: 'CHF all\'ora',
      addCategoriesPersonnel: 'Aggiungi categorie di personale',
      value: 'Valore',
      material: 'Materiale',
      surcharge: 'Sovrapprezzo',
      foreignService: 'Servizio estero',
      inventory: 'Inventario',
      amount: 'Importo',
      additionalCosts: 'Costi aggiuntivi',
      addCostCategories: 'Aggiungi categorie di costi',
      currentDate: 'Data attuale',
      dateLastFriday: 'Appuntamento venerdì scorso',
      addCategoriesMaterial: 'Aggiungi categorie di materiali',
      addCategoriesForeignService: 'Aggiungi categorie di servizi esteri',
      addCategoriesInventory: 'Aggiungi categorie di inventario',
      addCategoriesAdditionalCosts: 'Aggiungi ulteriori categorie di costi',
      thisFieldIsRequired: 'Questo campo è obbligatorio',
      actualCosts: 'Costi effettivi',
      budget: 'Bilancio',
      summary: 'Sommario',
      work: 'Opera',
      date: 'Data',
      amountOfHours: 'Quantità di ore',
      total: 'Totale',
      costs: 'Costi',
      unit: 'Unità',
      costsUpdated: 'Costi aggiornati correttamente',
      orderByStartDate: 'Ordina per data di inizio',
      selectCategoryForSorting: 'Seleziona la categoria per l\'ordinamento',
      yourParticipationOnProject: 'La tua partecipazione al progetto',
      yourParticipationStarts: 'La tua partecipazione inizia',
      yourParticipationEnds: 'La tua partecipazione termina',
      pleaseCreateCategory: 'Crea almeno una categoria di costo prima di procedere all\'aggiunta di righe.',
      dynamicBudget: 'Budget dinamico',
      updateOverallDetails: 'Aggiorna i dettagli generali',
      addRowWithNewDate: 'Aggiungi riga con nuova data',
      sheetSuccesfullyUpdated: 'I dettagli dell\'attività sono stati aggiornati correttamente.',
      projectsWithThisNameAlreadyExists: 'Il progetto con questo nome esiste già.',
      preferredLanguage: 'Lingua preferita',
      filterProjects: 'Progetti di filtro',
      addAnotherCostLine: 'Aggiungi un\'altra linea di costo per la stessa data',
      removeCostLine: 'Rimuovi la linea di costo',
      addACategory: 'Aggiungi una categoria',
      deviationFromTargetCosts: 'Deviazione dai costi target',
      deviationFromBudget: 'Deviazione dal budget',
      overallProjectData: 'Dati generali del progetto',
      downloadToCsv: 'Scarica il rapporto CSV',
      notPossibleToCalculate: 'Non è possibile calcolare',
      deleteCostRow: 'Sei sicuro di voler eliminare la riga? È già stato salvato nel database',
      backToProjectPage: 'Torna alla pagina del progetto',
      backToDashboard: 'Torna alla dashboard',
      leavePage: 'Vuoi davvero lasciare la pagina? Hai modifiche non salvate!',
      deleteRowNotAllowed: 'Non puoi eliminare questa riga, deve essercene una per ogni mese. Se non ci sono spese, lascia gli zeri.',
      addUpdateProfileImage: 'Aggiungi / aggiorna l\'immagine del profilo al clic',
      coverImageSuccesfullyUpdated: 'Immagine di copertina aggiornata con successo.',
      addUpdate: 'Aggiungi / Aggiorna',
      rollingForecast: 'Previsioni a rotazione',
      costsAndDates: ' costi e date',
      setStartDateFor: 'Impostare la data di inizio per ',
      taskOnTheProject: ' compito sul progetto',
      price: 'Prezzo',
      nonFieldErrors: 'Altri errori',
      passwordNotComplex: 'Inserisci la password di almeno 8 caratteri, con almeno 1 carattere minuscolo, 1 carattere maiuscolo e almeno 1 cifra.',
      dateOutOfRange: 'La data selezionata deve essere compresa nell\'intervallo tra la data di inizio del progetto e la data di fine',
      youHaveToProvideStartDate: 'Devi fornire la data di inizio per il lavoro dell\'artigiano sul progetto.',
      totalCostsProjectLeader: 'Capo progetto costi totali',
      addDocument: 'Aggiungi un documento',
      chooseFile: 'Scegli un file',
      documentSuccesfullyUploaded: 'Documento / i caricato / i correttamente.',
      listAlreadyAdded: 'Elenco dei documenti già aggiunti',
      renameUploadedFile: 'Rinominare il file in modo che non contenga spazi bianchi.',
      companyAbbreviation: 'Abbreviazione dell\'azienda',
      invoiced: 'Fatturata',
      file: 'File',
      theSubmittedDataWasNotAFileCheckTheEncodingTypeOnTheForm: 'Il file inviato non è valido',
      lock: 'Serrare',
      budgetHistory: 'Cronologia del budget',
      totalInvoiced: 'Totale fatturato',
      month: 'Mese',
      filterDocumentsPerMonth: 'Filtra i documenti al mese',
      filter: 'Filtra',
      cancel: 'Annullare',
      personnel_locked: 'Il budget per il personale è stato chiuso dall\'amministratore. Dovrà essere approvato dall\'amministratore prima di poter iniziare a usarlo.',
      material_locked: 'Il budget per il materiale è stato chiuso dall\'amministratore. Dovrà essere approvato dall\'amministratore prima di poter iniziare a usarlo..',
      foreign_power_locked: 'Il budget per il servizio estero è stato chiuso dall\'amministratore. Dovrà essere approvato dall\'amministratore prima di poter iniziare a usarlo.',
      inventory_locked: 'Il budget per l\'inventario è stato chiuso dall\'amministratore. Dovrà essere approvato dall\'amministratore prima di poter iniziare a usarlo.',
      additional_costs_locked: 'Il budget per costi aggiuntivi è stato chiuso dall\'amministratore. Dovrà essere approvato dall\'amministratore prima di poter iniziare a usarlo.',
      approveUsingOf: 'Sei sicuro di voler approvare l\'utilizzo di',
      forbidUsingOf: 'Sei sicuro di voler vietare l\'uso di',
      provideCorrectFormat: 'Fornisci l\'immagine nel formato jpg o png corretto.',
      requestAdditionalBudget: 'Richiedi un budget aggiuntivo',
      additionalBudgetSuccessfullyRequested: 'Hai inviato correttamente la richiesta di budget aggiuntivo. Riceverai una notifica quando l\'amministratore gestisce la tua richiesta.',
      additionalBudgetAllowed: 'Additional budget allowed',
      lockAllBudget: 'Blocca tutto il budget',
      unlockAllBudget: 'Sblocca tutto il budget',
      youAreNotAble: 'Non è possibile aggiungere ulteriori categorie se l\'amministratore non lo ha autorizzato.',
      theBudgetIsLocked: 'Il budget è bloccato.',
      areSureConfirmBudget: 'Sei sicuro di voler confermare il budget e informare l\'amministratore?',
      areYouSureLock: 'Sei sicuro di voler bloccare tutti i campi e informare l\'utente?',
      areYouSureUnlock: 'Sei sicuro di voler sbloccare tutti i campi e informare l\'utente?',
      adminClosedBudget: 'L\'amministratore ha chiuso il tuo budget.',
      adminOpenedBudget: 'L\'amministratore ha aperto il tuo budget.',
      updateCategoryName: 'Aggiorna il nome della categoria',
      importCategories: 'Importa categorie',
      personnel: 'Personale',
      selectedCategories: 'Categorie selezionate',
      import: 'Import',
      selectProject: 'Seleziona progetto',
      filterCraftsmen: 'Filtra gli artigiani',
      addBudgetFirst: 'Devi aggiungere il budget prima di confermare che è stato fatto.',
      documentSuccesfullyRemoved: 'Documento rimosso con successo.',
      areYouSureRemove: 'Sei sicuro di voler eliminare il documento selezionato?',
      invoiceLineAdded: 'Riga fattura aggiunta correttamente.',
      oopsSomethingWentWrong: 'Ops! Qualcosa è andato storto.',
      afterClickingPlsCheck: 'Dopo aver fatto clic sul documento richiesto, controlla le altre schede o la cartella dei download del tuo browser.',
      noCategoriesToImport: 'Nessuna categoria da importare.',
      contractNumber: 'Numero del contratto',
      budgetDone: 'Bilancio fatto',
      inputAdditionalBudget: 'Devi inserire la somma per un budget aggiuntivo.',
      hasRequestedAdditionalBudget: 'ha richiesto un budget aggiuntivo di',
      notifications: 'Notifiche',
      new: 'Nuovo',
      clearAll: 'Cancella tutto',
      done: 'Fatto',
      tasks: 'Compiti',
      bkp: 'BKP',
      listOfBkp: 'Elenco dei BKP',
      selectBkp: 'Seleziona BKP',
      backToTasks: 'Torna alle attività',
      approve: 'Approvare',
      deny: 'Negare',
      areYouSureThatYouWantToApprove: 'Sei sicuro di voler approvare un budget aggiuntivo per',
      areYouSureThatYouWantToDeny: 'Sei sicuro di voler negare un budget aggiuntivo per',
      adminApprovedAdditionalBudget: 'L\'amministratore ha approvato un budget aggiuntivo per il tuo account',
      adminDeniedAdditionalBudget: 'L\'amministratore ha rifiutato la tua richiesta di budget aggiuntivo',
      noNewTasks: 'Nessuna nuova attività',
      noDoneTasks: 'Nessun compito svolto',
      additionalBudgetHistory: 'Cronologia del budget aggiuntiva',
      addNewBkp: 'Aggiungi nuovo BKP',
      theNameOfBkp: 'The name of BKP',
      updateContract: 'Contratto di aggiornamento',
      updateContractNumber: 'Aggiorna il numero del contratto',
      contractNoSuccesfullyUpdated: 'Numero del contratto aggiornato con successo.',
      ensureThisValueIsGreaterThanOrEqualTo001: 'Assicurati che questo valore sia maggiore di 0.',
      planner: 'Progettista',
      descriptionInvoiceNumber: 'Descrizione (numero fattura)',
      amountChfExclVat: 'Importo (CHF IVA esclusa)',
      bkpDescription: 'Descrizione BKP',
      updateBkp: 'Aggiorna BKP',
      searchForCraftsmenByBKP: 'Cerca artigiani per BKP',
      searchBy: 'Cercato da ',
      areYouSureDeleteBudget: 'Sei sicuro di voler eliminare questo budget aggiuntivo?',
      additionalBudgetSuccesfullyRemoved: 'Budget aggiuntivo rimosso con successo.',
      projectController: 'Controller di progetto',
      plsSelectOne: 'Per favore selezionane uno',
      plsSetYourStaticBudget: 'Si prega di impostare il budget statico per il contratto.',
      createdBy: 'Controller di progetto',
      lockStaticBudget: 'Blocca budget statico',
      addUpdateProjectColor: 'Aggiungi / aggiorna il colore del progetto',
      updateProjectColor: 'Aggiorna il colore del progetto',
      mustSelectBKP: 'Devi selezionare BKP prima di aggiungere artigiani al progetto.',
      addAdditionalBudget: 'Aggiungi ulteriore budget',
      additionalBudgetSuccessfullyAdded: 'Budget aggiuntivo aggiunto correttamente.',
      serialNumber: 'Numero di serie',
      offerNumber: 'Numero dell\'offerta',
      forMonth: 'Per mese',
      allAdditionalBudgetsSuccessfullyAdded: 'Tutti i budget aggiuntivi aggiunti correttamente.',
      companies: 'Aziende',
      listOfCompanies: 'Elenco delle società',
      addNewCompany: 'Aggiungi nuova società',
      companySuccessfullyCreated: 'Azienda creata con successo',
      updateCompany: 'Aggiorna azienda',
      companySuccessfullyUpdated: 'Azienda aggiornata con successo.',
      removeAdditionalBudget: 'Rimuovere budget aggiuntivo',
      saveAdditionalBudget: 'Risparmia budget aggiuntivo',
      areYouSureYouWantAddUser: 'Sei sicuro di voler aggiungere l\'utente con i seguenti dati al progetto?',
      setContractNumber: 'Imposta il numero del contratto',
      contractNumberIsMandatoryField: 'Il numero del contratto è un campo obbligatorio.',
      endDateOfSheetIsOutOfRangeOfProject: 'la data di fine del foglio non rientra nell\'intervallo del progetto.',
      badRequest: 'Brutta richiesta',
      descriptionOrOfferNumberOrAdditionalBudgetDataNotCorrect: 'descrizione o numero dell\'offerta o dati di budget aggiuntivi non corretti.',
      setStaticBudget: 'Imposta budget statico',
      staticBudgetPlusAdditionalBudget: 'Budget statico + Budget aggiuntivo',
      data: 'Dati',
      additionalBudget: 'Budget aggiuntivo',
      settings: 'Impostazioni',
      addUpdateAppLogo: 'Aggiungi / aggiorna il logo dell\'applicazione',
      addUpdateTabText: 'Aggiungi / aggiorna il testo della scheda',
      appDetailsUpdated: 'Dettagli dell\'applicazione aggiornati con successo.',
      features: 'CARATTERISTICHE',
      reporting: 'Segnalazione',
      dynamicBudgetUpToCurrentMonth: 'Budget dinamico fino al mese corrente',
      actualCostsUpToCurrentMonth: 'Costi effettivi fino al mese corrente',
      dataTable: 'Tabella dati',
      deviation: 'Deviazione',
      showHide: 'Mostra nascondi',
      show: 'Mostra',
      hide: 'Nascondi',
      informAutomaticContractNumber: 'Si noti inoltre che il campo del numero di contratto era vuoto e che è stato impostato automaticamente.',
      rest: 'riposo',
      errors: 'Errori',
      notes: 'Appunti',
      updateNotes: 'Aggiorna le note',
      addaNewNote: 'Aggiungi una nuova nota',
      text: 'Testo della nota',
      succesfullyAdded: 'aggiunto con successo',
      note: 'Nota',
      this: 'questa',
      succesfullyDeleted: 'cancellato con successo',
      goToLockMonths: 'Vai a bloccare i mesi',
      lockMonths: 'Blocca mesi',
      messaging: 'Messaggistica',
      subject: 'Soggetto',
      messageBody: 'Messaggio del corpo',
      send: 'Spedire',
      emailArchive: 'Archivio email',
      sendEmailAlerts: 'Invia avvisi e-mail',
      closeSheet: 'Chiudi foglio',
      areYouSureDeleteCategory: 'Sei sicuro di voler eliminare questa categoria?',
      category: 'Categoria',
      pleaseNoteCostsAlso: 'Si prega di notare che anche tutti i costi relativi a questa categoria verranno eliminati.',
      goToTaskHistory: 'Vai alla cronologia delle attività',
      taskHistory: 'Cronologia attività',
      details: 'Dettagli',
      created: 'Creata',
      approveadditionalbudget: 'Approva budget aggiuntivo',
      admin: 'Admin',
      issuedBy: 'Rilasciato da',
      showMoreRows: 'Mostra più righe',
      closedByAdministrator: 'Chiuso dall\'amministratore',
      lateWithInput: 'Voci mancanti mese precedente',
      lateWithInputCurrentMonth: 'Voci mancanti per il mese corrente',
      zeroValueAdded: 'Voci mancanti per il mese corrente',
      sheetClosed: 'Foglio chiuso',
      costsAdded: 'Costi aggiunti',
      dashboardVisibleForCraftsmen: 'Cruscotto visibile per artigiani / pianificatori',
      yourContracts: 'I tuoi contratti',
      listOfWork: 'Elenco dei lavori',
      addNewWork: 'Aggiungi nuovo lavoro',
      updateWork: 'Aggiorna il lavoro',
      theNameOfWork: 'Numero di lavoro',
      workDescription: 'Descrizione del lavoro',
      clickToAddCosts: 'Fare clic per aggiungere i costi',
      selectWork: 'Seleziona lavoro',
      job: 'Lavoro',
      distributionActuals: 'Distribuzione dei costi effettivi',
      distributionBudget: 'Distribuzione dei costi di budget',
      documents: 'Documenti',
      createArchive: 'Crea archivio',
      invoice: 'Fattura',
      offer: 'Offrire',
      action: 'Azione',
      filterByCategory: 'Filtra per categoria',
      archiveZipFile: 'Il file zip di archivio è in fase di generazione. Tra un paio di minuti ti invitiamo a visitare',
      listArchivesCreated: 'Elenco degli archivi creati',
      creationCompleted: 'Elenco degli archivi creati',
      completed: 'Completato',
      notCompleted: 'Non completato',
      emailAlertSettingChangedSuccesfully: 'L\'impostazione dell\'avviso e-mail è stata modificata correttamente.'
    }
  }
}
